import React, {useEffect, useState} from "react";
import associateServices from "../../../services";
import Loading from "../../../components/loading";
import {useTranslation} from "react-i18next";
import moment from "moment/moment";
import TableFooter from "../../../components/table-footer/TableFooter";
import NoData from "../../../components/no-data";
import CLIPBOARD_HELPER from "../../../helpers/clipboard-helpers";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";
import FormButton from "../../../components/form-button";
import {useSearchParams} from "react-router-dom";
import SvgIcon from "../../../components/svg-icon";
import InstrumentIcon from "../../../components/instrument-icon";
import Big from "big.js";
import TableFooterCampaign from "../../../components/table-footer-campaign/TableFooter";

const AffiliateCampaigns = (props) => {
    const [loading, setLoading] = useState(true)
    const [total, setTotal] = useState(0)
    const [data, setData] = useState([])
    const [stats, setStats] = useState({})
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [searchParams, setSearchParams] = useSearchParams()

    const {t} = useTranslation()

    useEffect(() => {
        getCampaigns()
    }, [page, limit])

    const getCampaigns = () => {
        setLoading(true)
        associateServices.getCampaigns({
            limit,
            page,
        }).then(res => {
            console.log(res?.data)
            setStats(res?.data?.stats)
            setData(res?.data?.campaigns?.data)
            setTotal(res?.data?.campaigns?.total)
            setLoading(false)
        })
    }
    const handlePrev = () => setPage(prevState => prevState <= 1 ? 1 : prevState - 1)
    const handleNext = () => setPage(prevState => prevState + 1)


    const handleCopy = (link) => {
        CLIPBOARD_HELPER.copy(link || '')

        toast(<InformationToast
            message={t('affiliate.campaigns.link-copied')}
            title={t('general.information')}
        />)
    }

    const handleCreate = type => {
        searchParams.set('modal', 'campaign')
        setSearchParams(searchParams)
        // setSearchParams({modal: 'campaign'})
    }


    return (
        <div className="tab-pane fade show active">
            <div className="tab-content">
                {
                    loading ? <Loading/> :
                        <>

                            <div className="col-12">
                                <div className="content">
                                    <div className="content__main content__main--big">
                                        <ul className="content__stats">
                                            <li>
                                                <span
                                                    className="content__stats-name">{t('affiliate.campaigns.campaign-hits')}</span>
                                                <span className="content__stats-value">{stats?.hit}</span>
                                            </li>
                                            <li>
                                                <span
                                                    className="content__stats-name">{t('affiliate.campaigns.referrals')}</span>
                                                <span className="content__stats-value">{stats?.referrals}</span>
                                            </li>
                                            <li>
                                                <span
                                                    className="content__stats-name">{t('affiliate.campaigns.total-deposits')}</span>
                                                <span className="content__stats-value">{stats?.deposit_count}</span>
                                            </li>
                                            <li>
                                                <span
                                                    className="content__stats-name">{t('affiliate.campaigns.unique-deposits')}</span>
                                                <span
                                                    className="content__stats-value">{stats?.distinct_deposit_count}</span>
                                            </li>
                                            <li>
                                                <span className="content__stats-name">
                                                    {t('affiliate.campaigns.available')}
                                                </span>
                                                <div>
                                                    {stats?.availables?.length >= 1 ? stats?.availables?.map(available => (
                                                        <span>
                                                                                <span
                                                                                    className="d-flex align-items-center gap-2">
                                                                                    <InstrumentIcon
                                                                                        code={available?.currency}/>
                                                                                    {Big(available?.amount || 0).toFixed(8)}
                                                                                </span>
                                                                            </span>
                                                    )) : '-'}
                                                </div>
                                            </li>
                                        </ul>


                                        {
                                            data?.map(item => (
                                                <div className="accordion-content">
                                                    <button
                                                        className="collapsed accordion-content__btn"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse${item.id}`}
                                                        aria-expanded="false"
                                                        aria-controls={`collapse${item.id}`}
                                                    >
                                                        <span className="accordion-content__name">{item?.name}</span>

                                                        {/*  <span className="accordion-content__value">*/}

                                                        {/*      <div>*/}
                                                        {/*          {item?.availables?.map(available => (*/}
                                                        {/*              <span>*/}
                                                        {/*                      <span>*/}
                                                        {/*                          <InstrumentIcon*/}
                                                        {/*                              code={available?.currency}/>*/}
                                                        {/*                          {Big(available?.amount || 0).toFixed(8)}*/}
                                                        {/*                      </span>*/}
                                                        {/*              </span>*/}
                                                        {/*          ))}*/}
                                                        {/*      </div>*/}

                                                        {/*</span>*/}


                                                        <span className="accordion-content__icon">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={24}
                                                        height={24}
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        strokeWidth={2}
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                      <path d="M6 9l6 6l6 -6"/>
                                                    </svg>
                                                  </span>
                                                    </button>
                                                    <div id={`collapse${item.id}`} className="collapse">
                                                        <div className="accordion-content__wrap">
                                                            <ul className="content__stats">
                                                                <li>
                                                                    <span
                                                                        className="content__stats-name">
                                                                        {t('affiliate.campaigns.campaign-hits')}
                                                                    </span>
                                                                    <span
                                                                        className="content__stats-value">{item?.click}</span>
                                                                </li>
                                                                <li>
                                                                    <span
                                                                        className="content__stats-name">
                                                                        {t('affiliate.campaigns.referrals')}
                                                                    </span>
                                                                    <span
                                                                        className="content__stats-value">{item?.usages_count}</span>
                                                                </li>
                                                                <li>
                                                                    <span
                                                                        className="content__stats-name">
                                                                        {t('affiliate.campaigns.total-deposits')}
                                                                    </span>
                                                                    <span
                                                                        className="content__stats-value">{item?.deposit_count}</span>
                                                                </li>
                                                                <li>
                                                                    <span className="content__stats-name">
                                                                         {t('affiliate.campaigns.unique-deposits')}
                                                                    </span>
                                                                    <span
                                                                        className="content__stats-value">{item?.distinct_deposit_count}</span>
                                                                </li>
                                                                <li>
                                                                    <span className="content__stats-name">
                                                                        {t('affiliate.campaigns.rate')}
                                                                    </span>
                                                                    <span
                                                                        className="content__stats-value">{item?.rate}</span>
                                                                </li>
                                                                <li>
                                                                    <span className="content__stats-name">
                                                                       {t('affiliate.campaigns.available')}
                                                                    </span>
                                                                    <div>
                                                                        {item?.availables?.map(available => (
                                                                            <span>
                                                                                <span
                                                                                    className="d-flex align-items-center gap-2">
                                                                                    <InstrumentIcon
                                                                                        code={available?.currency}/>
                                                                                    {Big(available?.amount || 0).toFixed(8)}
                                                                                </span>
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </li>
                                                                <li>
                                                            <span
                                                                className="content__stats-name">
                                                                 {t('affiliate.campaigns.total')}
                                                            </span>
                                                                    <div>
                                                                        {item?.history?.map(available => (
                                                                            <span>
                                                                                <span
                                                                                    className="d-flex align-items-center gap-2">
                                                                                    <InstrumentIcon
                                                                                        code={available?.currency}/>
                                                                                    {Big(available?.amount || 0).toFixed(8)}
                                                                                </span>
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </li>


                                                            </ul>
                                                            <div className="form__group">
                                                              <span className="form__label">
                                                                {t('affiliate.campaigns.link')}
                                                              </span>
                                                                <div className="form__wallet">
                                                                    <input
                                                                        type="text"
                                                                        className="form__input"
                                                                        defaultValue={item?.link}
                                                                    />
                                                                    <div className="form__actions">
                                                                        <button type="button"
                                                                                onClick={e => handleCopy(item.link)}>

                                                                            <SvgIcon id={'copy'}/>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }


                                        <TableFooterCampaign
                                            total={total}
                                            limit={limit}
                                            handlePrev={handlePrev}
                                            handleNext={handleNext}
                                            handleCreate={handleCreate}
                                            section={'debit'}
                                            page={page}
                                            buttonText={null}
                                        />

                                    </div>
                                </div>
                            </div>

                            {/*<div className="tab-pane fade show active">*/}
                            {/*    <div className="table-responsive">*/}
                            {/*        {*/}
                            {/*            data?.length <= 0 ? <NoData desc={t('transactions.bets.empty')}/> :*/}
                            {/*                <table className="xtable xtable--small">*/}
                            {/*                    <thead>*/}
                            {/*                    <tr>*/}
                            {/*                        <th>{t('affiliate.campaigns.table.name')}</th>*/}
                            {/*                        <th>{t('affiliate.campaigns.table.secret')}</th>*/}
                            {/*                        <th>{t('affiliate.campaigns.table.time')}</th>*/}
                            {/*                        <th>{t('affiliate.campaigns.table.total')}</th>*/}
                            {/*                        <th>{t('affiliate.campaigns.table.link')}</th>*/}
                            {/*                    </tr>*/}
                            {/*                    </thead>*/}
                            {/*                    <tbody>*/}

                            {/*                    {*/}
                            {/*                        data?.map(debit => (*/}
                            {/*                            <tr key={debit?.id}>*/}
                            {/*                                <td className="cursor-pointer">*/}
                            {/*                                    <div*/}
                            {/*                                        className="xtable__text xtable__text--text-secondary">*/}
                            {/*                                        {debit?.name}*/}
                            {/*                                    </div>*/}
                            {/*                                </td>*/}
                            {/*                                <td>*/}
                            {/*                                    <div className="xtable__text xtable__text--green">*/}
                            {/*                                        {debit?.secret}*/}
                            {/*                                    </div>*/}
                            {/*                                </td>*/}
                            {/*                                <td>*/}
                            {/*                                    <div className="xtable__text">*/}

                            {/*                        <span className="xtable__text-date">*/}
                            {/*                                            {moment.unix(debit?.timestamp || 0).format('MMMM Do')}*/}

                            {/*                            <small>*/}
                            {/*                                            {moment.unix(debit?.timestamp || 0).format('h:mm:ss a')}*/}
                            {/*                                        </small>*/}
                            {/*                                        </span>*/}

                            {/*                                    </div>*/}
                            {/*                                </td>*/}


                            {/*                                <td>*/}
                            {/*                                    <div className="xtable__text">*/}
                            {/*                                        {debit?.usages_count || '0.00'}*/}
                            {/*                                    </div>*/}
                            {/*                                </td>*/}
                            {/*                                <td>*/}
                            {/*                                    <div className="xtable__text gap-2">*/}
                            {/*                                        {debit?.link || '-'}*/}
                            {/*                                        <button type="button"*/}
                            {/*                                                data-tooltip-id="copy-tooltip"*/}
                            {/*                                                data-tooltip-content={'Copy'}*/}
                            {/*                                                data-tooltip-place="top"*/}
                            {/*                                                onClick={e => handleCopy(debit)}*/}
                            {/*                                        >*/}
                            {/*                                            <SvgIcon id={'copy'}/>*/}
                            {/*                                        </button>*/}
                            {/*                                    </div>*/}
                            {/*                                </td>*/}


                            {/*                            </tr>*/}
                            {/*                        ))*/}
                            {/*                    }*/}

                            {/*                    </tbody>*/}
                            {/*                </table>*/}

                            {/*        }*/}
                            {/*    </div>*/}
                            {/*    <TableFooter*/}
                            {/*        total={total}*/}
                            {/*        limit={limit}*/}
                            {/*        handlePrev={handlePrev}*/}
                            {/*        handleNext={handleNext}*/}
                            {/*        section={'debit'}*/}
                            {/*        page={page}*/}
                            {/*        buttonText={null}*/}
                            {/*    />*/}
                            {/*</div>*/}
                        </>

                }

            </div>

            {/*<div className="settings__btns">*/}
            {/*    <FormButton*/}
            {/*        onClick={handleCreate}*/}
            {/*        isSmall={true}*/}
            {/*        loading={loading}*/}
            {/*        disabled={false}*/}
            {/*        label={t('affiliate.campaigns.create-campaign')}*/}
            {/*    />*/}
            {/*</div>*/}
        </div>
    )
}

export default AffiliateCampaigns
